"use strict";

angular.module("models").service("EmailHistoryService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("emails", ["subject", "from", "to", "cc", "bcc", "reports", "report"], function (element) {
    return element.subject ? element.subject : "???";
  }));
}]);